import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Loader from 'components/Loader';
import FormContainer from 'components/LoanForm/FormContainer';
import { getApplicationData } from 'selectors/getApplicationData';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { FlowComponentType } from 'routes/types';
import { updateOfferWithVerifiedIncome } from 'thunks';
import { formatMonetaryAmount } from 'utils/formatMonetaryAmount';
import { VerifyIncomeResult } from 'enums/FlowNextResults';

import styles from './VerifyIncome.module.scss';

const VerifyIncome = ({ handleNext }: FlowComponentType) => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const { application, isLoading: isApplicationLoading } = useSelector(getApplicationData);
  const totalAnnualIncome = application?.totalAnnualIncome;
  const verifiedAnnualIncomeAmount = application?.employment?.employer1?.verifiedAnnualIncomeAmount;

  const [isLoading, setIsLoading] = useState(false);

  const handleUpdateIncome = async () => {
    setIsLoading(true);
    await dispatchWithUnwrap(updateOfferWithVerifiedIncome({ applicationId: application!.id }));
    handleNext(VerifyIncomeResult.UpdateAnnualIncome);
  };

  if (isLoading || isApplicationLoading) {
    return (
      <FormContainer>
        <div className={styles.loaderContainer}>
          <Loader color="#795af7" />
        </div>
      </FormContainer>
    );
  }

  return (
    <FormContainer
      title={
        <p className={styles.title}>
          Your verified income is {formatMonetaryAmount(verifiedAnnualIncomeAmount)}{' '}
          <span>of {formatMonetaryAmount(totalAnnualIncome)}</span>
        </p>
      }
      subtitle="You can verify more income, or update your offer with the lower amount."
    >
      <p className={styles.actionsTitle}>Choose an option:</p>
      <div className={styles.actions}>
        <div className={styles.cardButton} onClick={() => handleNext()}>
          <p>Verify your reported income of {formatMonetaryAmount(totalAnnualIncome)}</p>
        </div>
        <div className={styles.cardButton} onClick={handleUpdateIncome}>
          <p>Update your offer with your verified income of {formatMonetaryAmount(verifiedAnnualIncomeAmount)}</p>
        </div>
      </div>
    </FormContainer>
  );
};

export default VerifyIncome;
